/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Question ids mapped to their selected option codes
 */
export type QuestionnaireResponseSubmissionRequestAnswers = {
  [key: string]: string | string[];
};
